import { INote } from '@/contracts/modules/note/entities/INote'
import { IConflict } from '@/contracts/modules/note/entities/IConflict'
import { IDocument } from '@/contracts/modules/note/entities/IDocument'
import { INoteFileRecord } from '@/contracts/modules/note/entities/INoteFileRecord'
import { IPlainNoteState } from '@/contracts/modules/note/use-case/IPlainNoteState'
import { Conflict } from '@/modules/note/v1/entities/Conflict'
import { Version } from '@/modules/note/v1/entities/Version'

export class Note implements INote {
  private conflict: IConflict | null

  constructor(private uuid: string, private state: IPlainNoteState) {
    this.conflict = state.conflict === null
      ? null
      : new Conflict(
        new Version(state.conflict.left.time, state.conflict.left.content),
        new Version(state.conflict.right.time, state.conflict.right.content),
        state.conflict.base,
      )
  }

  getUuid(): string {
    return this.uuid
  }

  getTitle(): string {
    return this.state.title
  }

  getContent(): IDocument {
    return this.state.content
  }

  getFormat(): number {
    if (this.conflict === null) {
      return this.state.content.format ?? 1
    }
    return Math.max(this.conflict.getLeft().getContent().format ?? 1, this.conflict.getRight().getContent().format ?? 1)
  }

  isRemoved(): boolean {
    return this.state.isRemoved
  }

  getConflict(): IConflict | null {
    return this.conflict
  }

  getHeads(): string[] {
    return this.state.heads
  }

  getUpdatedAt(): string | null {
    return this.state.updatedAt
  }

  getFiles(): INoteFileRecord[] {
    return this.state.files
  }
}
